import styled from '@emotion/styled';
import { useMatchList } from './useMatchList';
import { MatchCard } from './MatchCard';
import { OfferCard } from './OfferCard';
import { PageTitle } from 'ui/components/elements/PageTitle/PageTitle';
import { AboutService } from 'ui/components/buyer/features/AboutService';
import { mqUser } from 'utils/responsive';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { DeclineMeetingRequest } from 'ui/components/screens/modals/DeclineMeetingRequest/DeclineMeetingRequest';
import { NeedProfileRegistration } from 'ui/components/buyer/screens/modals/NeedProfileRegistration/NeedProfileRegistration';

const tabs = ['チャットの開通', 'プレミアムオファー'];

const descriptions: { [key: string]: string[] } = {
    チャットの開通: [
        'ここでは、オファーが来た仲介会社の一覧が表示されます。',
        '気になる仲介会社には、オファーを受けてチャットを開通させましょう。',
        'チャット開通後は、メニュー内の「メッセージ」でやり取りが可能です。',
    ],
    プレミアムオファー: [
        'プレミアムオファーは、仲介会社からあなたへ「ぜひお話をさせてほしい！」という熱意を持った特別なオファーです。',
        '一度お話を聞いてみることをおすすめいたします。',
    ],
};

const Wrapper = styled.div`
    padding: 18px 50px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    text-align: left;
    background-color: #f8f9fd;
    height: auto;
    min-height: calc(100vh - var(--height-pc-header));

    ${mqUser('SP')} {
        padding: 18px 15px;
    }
`;

const MatchListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0;
    margin-top: 20px;
`;

const OfferListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0;
    margin-top: 20px;
`;

export const MatchList: React.FC = () => {
    const {
        loading,
        matchList,
        offerList,
        accept,
        decline,
        showSnackbarMessage,
        showSnackbar,
        setShowSnackbar,
        setValue,
        errors,
        openModal,
        createModal,
        needShowModal,
        openNeedRegistrationModal,
        createNeedRegistrationModal,
    } = useMatchList();

    const onClickDeclineButton = (match_id: number) => {
        if (needShowModal) {
            openNeedRegistrationModal();
            return;
        }
        setValue('match_id', match_id);
        openModal();
    };

    const onClickAcceptButton = (match_id: number) => {
        if (needShowModal) {
            openNeedRegistrationModal();
            return;
        }
        accept(match_id);
    };

    return (
        <Wrapper>
            {createNeedRegistrationModal(<NeedProfileRegistration />)}
            <PageTitle title="オファー企業一覧" />
            <AboutService descriptions={descriptions} tabs={tabs} />
            {offerList.length > 0 && (
                <OfferListContainer>
                    <h4>オファー（承認またはお断りしてください）</h4>
                    {offerList.map((offer) => (
                        <OfferCard
                            key={offer.id}
                            offer={offer}
                            onAccept={onClickAcceptButton}
                            onDecline={onClickDeclineButton}
                        />
                    ))}
                </OfferListContainer>
            )}
            <MatchListContainer>
                <h4>マッチング済み</h4>
                {matchList.map((match) => (
                    <MatchCard key={match.id} match={match} />
                ))}
            </MatchListContainer>
            {createModal(
                <DeclineMeetingRequest
                    onClick={decline}
                    setValue={(value) => setValue('reason', value)}
                    errorMsg={errors.reason?.message || ''}
                    loading={loading}
                />,
            )}
            <SnackBar message={showSnackbarMessage} open={showSnackbar} setOpen={setShowSnackbar} />
        </Wrapper>
    );
};
